import { customizeValidator } from '@rjsf/validator-ajv8'

export const parametersValidator = customizeValidator({
  ajvOptionsOverrides: { keywords: [{ keyword: 'zocksReference' }, { keyword: 'zocksUi' }] },
})
